export default __webpack_public_path__ + "static/media/about_us_right.3441d5ed.png";